import React, { Component } from "react";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import { fetchDataAsync } from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import {
  ACTIVITY_TYPE,
  GenericSequenceType,
  HttpStatus,
} from "../../../common/Constants";
import { BOOKING_STATUS_OPTIONS } from "../config";
import moment from "moment";
import { flattenFormGroupObject, mapToObjectDDL } from "../../../common/mapper";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import { constructPayloadSubmit } from "../service";

moment.locale("id");

class ManagementBookingDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeOptions: [],
      managementBookingIdPlaceholder: null,
      statusOptions: BOOKING_STATUS_OPTIONS,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const currBookingDate = this.props.controls.bookingDate?.value;
    const prevBookingDate = prevProps.controls.bookingDate?.value;
    if (currBookingDate !== prevBookingDate) {
      this.fetchDataTime({
        date: currBookingDate,
        day: moment(currBookingDate, "DD-MM-YYYY").format("dddd"),
      });
    }
  }

  componentDidMount() {
    this.loadInitialData();
  }

  loadInitialData = async () => {
    const { setValue, activityType } = this.props;

    if (activityType === ACTIVITY_TYPE.CREATE) {
      this.fetchSequencePlaceholder();
      setValue("kodeCabang", this.props.selectedCabang);
      setValue("bookingStatus", BOOKING_STATUS_OPTIONS[1]);
    }
    const getDetailActivity = [ACTIVITY_TYPE.VIEW, ACTIVITY_TYPE.UPDATE];
    if (getDetailActivity.includes(activityType)) {
      this.fetchDataDetail();
    }
  };

  fetchDataDetail = async () => {
    const { setValue, detail, onTriggerLoading, cabangOptions } = this.props;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailManagementBooking,
      menuName: "Management Booking",
      setError: this.props.setError,
      args: {
        managementBookingId: detail.selectedId,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const data = res.data.data;
      setValue("bookingId", data.bookingId || null);
      setValue("bookingDate", data.bookingDate);
      setValue("bookingManagementDate", data.bookingManagementDate);
      setValue("bookingTime", {
        label: data.bookingTime,
        value: data.bookingTime
      });
      setValue("customerName", data.customerName);
      setValue("managementBookingId", data.managementBookingId);
      setValue("noteProblem", data.noteProblem);
      setValue("plateNumber", data.plateNumber);
      setValue("waHPNumber", data.waHPNumber);
      setValue(
        "kodeCabang",
        cabangOptions?.find((item) => item.value === data.kodeCabang)
      );
      setValue(
        "bookingStatus",
        BOOKING_STATUS_OPTIONS.find((item) => item.label === data.bookingStatus)
      );
    }
  };

  fetchDataTime = async ({ date, day }) => {
    const { selectedCabang } = this.props;
    this.props.onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getTimeForManagementBooking,
      menuName: "Management Booking",
      setError: this.props.setError,
      args: {
        kodeCabang: selectedCabang?.value,
        bookingDate: date,
        bookingDay: day?.toUpperCase(),
      },
    });
    this.props.onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        timeOptions: res.data.data.map((item) => ({
          ...mapToObjectDDL(item.bookingTime, item.bookingTime),
          bookingId: item.bookingId,
        })),
      });
    }
  };

  fetchSequencePlaceholder = async () => {
    this.props.onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getGenSeqWithoutSave,
      menuName: "Master Harga Jasa",
      setError: this.props.setError,
      args: {
        seqType: GenericSequenceType.MANAGEMENT_BOOKING,
        nosDealerCode: this.props.selectedCabang?.value,
        transactionType: GenericSequenceType.MANAGEMENT_BOOKING,
      },
    });
    if (res.ok && res.data) {
      this.setState({
        managementBookingIdPlaceholder: res.data,
      });
    }
    this.props.onTriggerLoading();
  };

  handleSave = async () => {
    const { validate, controls, onTriggerLoading, onClickClose, onRefresh } =
      this.props;
    if (validate()) {
      onTriggerLoading();
      const flattenFormData = flattenFormGroupObject(controls);
      const payload = constructPayloadSubmit(flattenFormData);
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").submitManagementBooking,
        menuName: "Management Booking",
        setError: this.props.setError,
        args: payload,
      });
      onTriggerLoading();
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        await onRefresh();
        onClickClose();
      }
    }
  };

  render() {
    const { visible, onClickClose, controls, setValue, errors, activityType, formGroup } =
      this.props;

    const { timeOptions, managementBookingIdPlaceholder, statusOptions } = this.state;

    const isReadonly = activityType === ACTIVITY_TYPE.VIEW;
    
    return (
      <SimpleModal
        visible={visible}
        title="Detail Manajemen Booking"
        onClickClose={() => onClickClose()}
        content={
          <ModalContainer>
            <div className="grid grid-2x gap-15px">
              <div className="column-1 gap-15px">
                <SimpleInput
                  id="cabang_name"
                  label="Cabang"
                  value={controls.kodeCabang?.value?.label}
                  readOnly
                />
                <SimpleInput
                  id="input_nama_customer"
                  label="Nama Customer"
                  mandatory
                  errorMessage={errors?.customerName}
                  name="customerName"
                  readOnly={isReadonly}
                  value={controls?.customerName?.value}
                  onChange={({ target }) => {
                    if (isReadonly) return;
                    setValue(target.name, target.value);
                  }}
                />
                <SimpleInput
                  id="input_nomor_wa"
                  label="Nomor WA/Telepon"
                  mandatory
                  name="waHPNumber"
                  box="onlyNumber"
                  errorMessage={errors?.waHPNumber}
                  readOnly={isReadonly}
                  value={controls?.waHPNumber?.value}
                  onChange={({ target }) => {
                    if (isReadonly) return;
                    setValue(target.name, target.value);
                  }}
                />
                <SimpleInput
                  id="input_nomor_plat"
                  label="Nomor Plat"
                  mandatory
                  name="plateNumber"
                  errorMessage={errors?.plateNumber}
                  readOnly={isReadonly}
                  value={controls?.plateNumber?.value}
                  onChange={({ target }) => {
                    if (isReadonly) {
                      return;
                    }
                    setValue(target.name, target.value);
                  }}
                />
                <SimpleDate
                  id="date_picker_tanggal_booking"
                  mandatory
                  label="Tanggal Booking"
                  name="bookingDate"
                  backdate
                  errorMessage={errors?.bookingDate}
                  disabled={isReadonly}
                  date={controls?.bookingDate?.value || null}
                  onChange={(value) => {
                    if (isReadonly) {
                      return;
                    }
                    setValue("bookingTime", null);
                    setValue("bookingDate", moment(value).format("DD-MM-YYYY"));
                  }}
                />
                <SimpleDDL
                  id="dropdown_jam_booking"
                  box="search"
                  label="Jam Booking"
                  name="bookingTime"
                  mandatory
                  isClearable
                  options={timeOptions}
                  readOnly={isReadonly}
                  errorMessage={errors?.bookingTime}
                  value={controls?.bookingTime?.value}
                  onChange={(value, { name }) => {
                    if (isReadonly) {
                      return;
                    }
                    setValue(name, value);
                  }}
                />
              </div>
              <div className="column-2 gap-15px">
                <SimpleInput
                  label="Nomor Booking"
                  value={
                    controls?.managementBookingId?.value ||
                    managementBookingIdPlaceholder
                  }
                  readOnly
                />
                <SimpleInput
                  label="Tanggal"
                  value={controls?.bookingManagementDate?.value}
                  readOnly
                />
                <SimpleTextArea
                  id={"text_area_problem"}
                  name={"noteProblem"}
                  label="Keluhan/Catatan"
                  mandatory
                  readOnly={isReadonly}
                  errorMessage={errors?.noteProblem}
                  value={controls?.noteProblem?.value}
                  inputStyles={{ height: "190px" }}
                  onChange={({ target }) => {
                    if (isReadonly) {
                      return;
                    }
                    setValue(target.name, target.value);
                  }}
                />
                <SimpleDDL
                  box="search"
                  label="Status"
                  name="bookingStatus"
                  readOnly={activityType === ACTIVITY_TYPE.CREATE || isReadonly}
                  isClearable
                  errorMessage={errors?.bookingStatus}
                  mandatory={formGroup.bookingStatus?.mandatory}
                  options={statusOptions}
                  onMenuOpen={() => {
                    this.setState(prev=>({
                      ...prev,
                      statusOptions: prev.statusOptions?.filter(item => item.value !== "SUCCESS" && item.value !== "UNCONFIRMED")
                    }))
                  }}
                  value={controls?.bookingStatus?.value}
                  onChange={(value, { name }) => setValue(name, value)}
                />
              </div>
            </div>
            {!isReadonly && (
              <FlexView hAlignContent="right">
                <SimpleButton
                  text="SIMPAN"
                  onClick={this.handleSave}
                />
              </FlexView>
            )}
          </ModalContainer>
        }
      />
    );
  }
}

export default withFormGroup(ManagementBookingDetail);
